<template>
  <div class="main-content">
    <el-scrollbar>
      <div class="content">
        <el-breadcrumb
          v-if="breadcrumbList.length > 0"
          separator="/"
        >
          <el-breadcrumb-item
            v-for="(item,index) in breadcrumbList"
            :key="index"
            :to="{ path: item.path }"
          >
            {{ item.title }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <!-- <div class="title">
          {{ title }}
        </div> -->
        <slot />
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
// import { routes } from '@/router';

export default {
  name: 'FixedHeader',
  components: { },
  data() {
    return {
      title: '页面标题',
      breadcrumbList: [],
    };
  },
  computed: {
    router() {
      return this.$route;
    },
  },
  watch: {
    $route() {
      // let isNull = false;
      // Object.values(val.params).forEach((value) => {
      //   if (value === undefined) {
      //     isNull = true;
      //   }
      // });
      // const paramLength = Object.keys(val.params).length;
      // const { title } = val.meta;
      // if (paramLength > 0 && !isNull) {
      //   // 编辑页面
      //   this.title = title.replace('新增', '编辑');
      // } else {
      //   this.title = title;
      // }
      this.initBreadcrumb();
    },
  },
  mounted() {
    this.initBreadcrumb();
  },
  methods: {
    // 生成面包屑
    initBreadcrumb() {
      this.breadcrumbList = [];
      const { path, matched } = this.$route;
      const pathArr = path.split('/');
      const path1 = pathArr[1];
      matched.forEach((m) => {
        if (m.path === `/${path1}`) {
          this.breadcrumbList.push({
            title: m.meta.title,
            path: m.path,
          });
        }
      });
      let isNull = false;
      Object.values(this.$route.params).forEach((value) => {
        if (value === undefined) {
          isNull = true;
        }
      });
      const paramLength = Object.keys(this.$route.params).length;
      const { title } = this.$route.meta;
      if (paramLength > 0 && !isNull) {
        // 编辑页面
        this.breadcrumbList.push({
          title: title.replace('新增', '编辑'),
          path,
        });
      } else {
        this.breadcrumbList.push({
          title,
          path,
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main-content {
  position: relative;
  height: 100vh;
  width: 100vw;
  padding-left: 150px;
  padding-top: 60px;
  .el-scrollbar {
    height: calc(100%);
    position: absolute;
    left: 150px;
    right: 0;
    ::v-deep .el-scrollbar__view{
      min-height: 100%;
    }
  }
  .content {
    padding: 0 80px 110px  25px;
    height: 100%;
    .el-breadcrumb{
      font-size: 16px;
      padding: 25px 0 8px 0;
      ::v-deep .el-breadcrumb__item{
        .el-breadcrumb__inner{
          color: rgba($--base-color-black, 0.8);
          font-weight: 500;
        }
        &:last-child{
          .el-breadcrumb__inner{
            color: rgba($--base-color-main, 0.8);
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
